import { DatabaseService, Event, EventData, EventRepository } from "@/core";
import { DatabaseCollection } from "./config";
import { getGenericRepository } from "./generic-repository";

export function getEventRepository(
  databaseService: DatabaseService,
): EventRepository {
  return getGenericRepository<Event, EventData>(
    () => DatabaseCollection.EVENTS,
    databaseService,
  );
}
